import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SMSTextService } from 'src/app/Service/SMSText/SMSText.service';

@Component({
  selector: 'app-SMSTextEdit',
  templateUrl: './SMSTextEdit.component.html',
  styleUrls: ['./SMSTextEdit.component.scss']
})
export class SMSTextEditComponent implements OnInit {
  EditRecord:Number

  constructor(
    private SMSText_Service:SMSTextService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditSMSText=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(40).subscribe(
      data=>{
        this.SMSText_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.get_Form_Dsc().setValue(data.code)

          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

    //#region  Form Add

    EditSMSText:FormGroup;

    get_Form_Id(){
      return this.EditSMSText.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditSMSText.get('Title') as FormControl;
    }

    get_Form_Dsc(){
      return this.EditSMSText.get('Dsc') as FormControl;
    }
    //#endregion

    InProccessing:boolean=false

    SubmitEditSMSText(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      Record.code=this.get_Form_Dsc().value
      this.InProccessing=true
      this.SMSText_Service.EditSMS_Text(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }
      )
    }



}
